import { ResetMegaMenu } from "./megamenu";
import { ResetMainMenu } from "./menu";
import { RespLangSearchSwitch } from "./responsivemenu";

/**
 * Search
 * Use: import { initSearch } from "./components/search";
 */
export function initSearch() {
	const	ShowSearchButton	= $('#toggle-search'),
			CloseSearchButton	= $('.search-close'),
			SearchInput			= $("#search_bar .search-input"),
			SearchLabel			= $("#search_bar label");
	
	// Show search bar
	ShowSearchButton.on( "click", function(){
		ShowSearch();
		ResetMegaMenu();
		ResetMainMenu();
	});

	// Hide search bar
	CloseSearchButton.on( "click", function(){
		hideSearch();
	});

	// Hide  label from start if input is not empty
	if( SearchInput.val() != '' ) {
		SearchLabel.addClass('hide');
	}

	// Hide label on input focus
	SearchInput.on('focus', function(){
		SearchLabel.addClass('hide');
	});

	// Show label on blur of input is empty
	SearchInput.on('blur', function(){
		const	$this	= $(this),
				Value	= $this.val();
		
		if( !Value ) {
			SearchLabel.removeClass('hide');
		}
	});

	$(document).on('keydown',function(evt) {
		if(evt.keyCode == 27) {
			hideSearch();
		}
	});
}

/**
 * Hide search bar
 * Use: import { hideSearch } from "./components/search";
 */
export function ShowSearch() {
	const	SearchBar	= $("#search_bar"),
			SearchInput = $("#search_bar .search-input");

	SearchBar.addClass( 'open' );
	SearchInput.focus();
}

/**
 * Hide search bar
 * Use: import { hideSearch } from "./components/search";
 */
export function hideSearch() {
	const SearchBar	= $("#search_bar");
	SearchBar.removeClass( 'open' );
}

/**
 * Responsive navigation search
 * Use: import { initResponsiveSearch } from "./components/search";
 */
export function initResponsiveSearch() {
	const	RespSearchInput		= $("#resp_search_bar .search-input"),
			RespSearchLabel		= $("#resp_search_bar label");

	// Hide  label from start if input is not empty
	if( RespSearchInput.val() != '' ) {
		RespSearchLabel.addClass('hide');
	}

	// Hide label on input focus
	RespSearchInput.on('focus', function(){
		RespSearchLabel.addClass('hide');
	});

	// Show label on blur of input is empty
	RespSearchInput.on('blur', function(){
		const	$this	= $(this),
				Value	= $this.val();
		
		if( !Value ) {
			RespSearchLabel.removeClass('hide');
		}
	});

	ResponsiveSearch();
}

/**
 * Open Navigation and place cursor in search filed when pressing search icon
 */
function ResponsiveSearch( ) {
	const	SearchButton		= $('#toggle-search-resp'),
			MobileNavContainer	= $("#mobile_nav_container"),
			NavToggleButton		= $("#toggle-responsive-nav"),
			SearchInput 		= $("#resp_search_bar .search-input");

	SearchButton.on( "click", function(){
		// Open responsive navigation and set correct aria variables/classes
		if (NavToggleButton.attr("aria-expanded") === "false") {
			NavToggleButton.attr("aria-expanded", true);
			RespLangSearchSwitch( true );

		} else {
			NavToggleButton.attr("aria-expanded", false);
			RespLangSearchSwitch( false );
		}

		NavToggleButton.toggleClass("open");
		MobileNavContainer.toggleClass('open');

		// Focus input field
		SearchInput.focus();
	});
}